import Raven from 'raven-js';
import identity from 'transmute/identity';
import { InMemoryCache } from '../InMemoryCache';
const fetchValidateUrl = (url, httpClient) => {
  return httpClient.post('property-validation/v1/property-validation/evaluate-proposed-rules', {
    data: {
      proposedRules: [{
        ruleType: 'URL',
        ruleArguments: []
      }],
      proposedValue: url
    }
  }).then(result => {
    if (result.length > 0) {
      return result[0];
    }
    return {
      isValid: true,
      error: null,
      message: null
    };
  }).catch(error => {
    Raven.captureException(error, {
      extra: {
        url
      }
    });
  });
};
export const makeUrlValidationCache = () => new InMemoryCache('UrlValidationCache', fetchValidateUrl, identity);